/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Payment_Mark_PaidInputs */



/**
* | output |
* | --- |
* | "Mark as paid" |
*
* @param {Payment_Mark_PaidInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const payment_mark_paid = /** @type {((inputs?: Payment_Mark_PaidInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Payment_Mark_PaidInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Marquer comme payé")
	if (locale === "es") return /** @type {LocalizedString} */ ("Marcar como pagado")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Marcar como pago")
	if (locale === "it") return /** @type {LocalizedString} */ ("Segna come pagato")
	return /** @type {LocalizedString} */ ("Mark as paid")
});